import { Subject } from '../observable/subject';
import { ObserverLike } from '../observable/observer';

export class ObservableSet<T> extends Set<T> {
  #subject = new Subject<Set<T>>();

  add = (value: T): this => {
    super.add(value);
    this.#subject.next(this);
    return this;
  };

  delete = (value: T): boolean => {
    const result = super.delete(value);
    this.#subject.next(this);
    return result;
  };

  clear = (): void => {
    super.clear();
    this.#subject.next(this);
  };

  subscribe = (observer: ObserverLike<Set<T>>): (() => void) => {
    const subscription = this.#subject.subscribe(observer);
    return () => subscription.unsubscribe();
  };
}
